
import { Component, Mixins } from 'vue-property-decorator';
import SettingsList from '@/features/settings/components/preferences/SettingsList.vue';
import Settings from '@/features/settings/components/preferences/Settings.vue';
import { scrollToInPage } from '@/features/common/helpers';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    SettingsList,
    Settings,
  },
})
export default class Preferences extends Mixins(ResponsivenessMixin) {
  // eslint-disable-next-line class-methods-use-this
  mounted(): void {
    scrollToInPage();
  }
}
